import { render } from "./MedicationAdministration.vue?vue&type=template&id=e6f509f0&scoped=true"
import script from "./MedicationAdministration.vue?vue&type=script&lang=js"
export * from "./MedicationAdministration.vue?vue&type=script&lang=js"

import "./MedicationAdministration.vue?vue&type=style&index=0&id=e6f509f0&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6f509f0"]])

export default __exports__